module.exports = __webpack_public_path__ + "img/vegetable-pea-shoots-190x100.9fc09700.jpg";